<template>
  <div class="content basicsSetting">
    <template>
      <el-tabs>
        <template v-for="(item, index) in tabData">
          <el-tab-pane :label="item" :key="index">
            <div class="header">
              模块设置
            </div>
            <keep-alive :max="10">
              <component :is="componentArr[index]"></component>
            </keep-alive>
          </el-tab-pane>
        </template>
      </el-tabs>
    </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  components: {
    basic: () => import("@/components/forumSetting/basic"),
    upTop: () => import("@/components/forumSetting/upTop"),
    redPacket: () => import("@/components/forumSetting/redPacket"),
    listShare: () => import("@/components/forumSetting/listShare"),
    watermark: () => import("@/components/forumSetting/watermark"),
    administrator: () => import("@/components/forumSetting/administrator"),
    messageRules: () => import("@/components/forumSetting/messageRules")
  },
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      page_id: "",
      listData: [], //列表
      page: 1,
      total: 0,
      loading: false, //页面loading
      componentArr: ["basic", "upTop", "redPacket", "listShare", "watermark", "administrator", "messageRules"],
      tabData: ["基本设置", "置顶设置", "红包设置", "列表分享", "水印设置", "管理员设置", "发帖设置"],
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
    };
  },
  mounted() {
    this.page_id = this.$route.params.id;
  },
  methods: {
  }
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 55px 30px 0;
  height: calc(100vh - 102px);
  border: 1px solid #f1f1f1;
  overflow: auto;
  min-width: 900px;
  // box-shadow: 0 0 3px #f1f1f1;
  .header {
    margin-left: 20px;
    border-bottom: 0;
    background-color: #f8f8f8;
    position: relative;
    padding: 10px 15px;
    padding-left: 28px;
    margin-bottom: 15px;
  }
  .header:after{
    content: '';
    position: absolute;
    width: 4px;
    height: 16px;
    background: #1AB394;
    border-radius: 30%;
    top: 50%;
    left: 10px;
    margin-top: -8px;
  }
}
</style>

<style lang="scss">
.basicsSetting {
  .el-tabs__nav-scroll {
    padding-left: 25px;
  }
}
</style>
